import * as I18n from './i18n'
export default {
  I18n,
}
